<template>
  <v-form>
    <v-container fluid>
      <v-row
        align="center"
        justify="center"
      >
        <v-col cols="12" sm="12" md="4" offset-md="2">
          <v-date-picker
            v-model="picker"
            reactive
            show-current
            @change="selectDate"
          ></v-date-picker>
        </v-col>
        <v-col cols="12" md="5">
          <v-row>
            <v-col cols="12">
              <v-btn @click="saveAttendance" color="primary">
                Save attendance
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-form @submit="onSubmit">
                <v-autocomplete
                  v-model="select"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  clearable
                  auto-select-first
                  autofocus
                  hide-selected
                  hide-details
                  label="Search Name"
                  solo
                  return-object
                  item-text="name"
                  item-value="objectID"
                  :no-filter="true"
                  @change="selectItem"
                >
                  <template v-slot:item="{item}">
                    <v-list-item-avatar
                      color="indigo"
                      class="headline font-weight-light white--text"
                    >
                      {{ item.name.charAt(0) }}
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.name"></v-list-item-title>
                      <v-list-item-subtitle v-text="item.gender"></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon>mdi-arrow-right</v-icon>
                    </v-list-item-action>
                  </template>
                </v-autocomplete>
              </v-form>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-simple-table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th class="text-left">Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, uuid, index) in attendanceList" :key="uuid">
                    <td>{{ index + 1 }}</td>
                    <td class="text-left">
                      {{ item.name }}
                    </td>
                    <td>
                      <v-btn
                        fab
                        dark
                        small
                        color="pink"
                        @click="removeUser(uuid)"
                      >
                        <v-icon dark>mdi-minus</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
      >
        {{ snackMessage }}
        <v-btn
          color="blue"
          text
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script type="ts">
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'
import * as db from '../plugins/db'
import omit from 'lodash.omit'

export default Vue.extend({
  methods: {
    selectItem () {
      const { ...user } = this.select
      console.log(user)
      this.$store.dispatch('addAttendance', {
        date: this.picker,
        user
      })
      this.$nextTick(() => {
        this.select = ''
      })
    },
    selectDate () {
      console.log('[INFO] Selected date:', this.picker)
      this.$store.dispatch('selectDate', this.picker)
    },
    removeUser (uuid) {
      this.$store.dispatch('deleteAttendance', {
        date: this.picker,
        user: uuid
      })
    },
    onSubmit (e) {
      e.preventDefault()
    },
    saveAttendance () {
      db.findAttendance(this.picker)
        .then((res) => {
          if (!res._hasPendingWrites) {
            this.snackMessage = `Attendance saved`
            this.snackbar = true
          }
        })
    }
  },

  data: function () {
    return {
      items: [],
      search: null,
      select: null,
      attendanceList: {},
      snackbar: false,
      snackMessage: '',
      timeout: 2000
    }
  },

  computed: {
    ...mapState([
      'nameList',
      'attendance',
      'attendanceLoading'
    ]),
    picker: {
      get () {
        return this.$store.state.currentDate
      },
      set (val) {
        this.$store.commit('setCurrentDate', val)
      }
    },
    isLoading () {
      return this.$store.state.attendanceLoading
    }
  },

  mounted: function () {
    this.selectDate()
  },

  created () {
    this.$store.dispatch('getNameList')
  },

  watch: {
    search (val) {
      if (val === '') return

      const searchOpts = {
        // includeScore: true,
        keys: ['name', 'nameChinese']
      }

      // Lazily load input items
      this.$search(val, this.nameList, searchOpts)
        .then(results => {
          // console.log(results, this.nameList)
          this.items = results
        })
        .catch(err => {
          console.log(err)
        })
    },
    attendanceLoading (val) {
      console.log('[INFO] watch attendanceLoading:', val)
      this.attendanceList = this.attendance[this.picker]
    }
  }
})
</script>
